(function(window, hotspotViewStateFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.hotspotViewState = hotspotViewStateFactory();
})(this, function() {
   'use strict';
   return Object.freeze({
      hidden: 'hidden',
      firstVisible: 'firstVisible',
      visible: 'visible'
   });
});
